import React from 'react';
import styles from '../css/comuns/Contato.module.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faWhatsapp } from '@fortawesome/free-brands-svg-icons';
import { faPhoneAlt } from '@fortawesome/free-solid-svg-icons';
import { config } from '../../data';

const Contato = () => {
    return (
        <div className={styles.contato}>
            <div className={styles.titulo}>{config.texts.contato.title}</div>
            <div className={styles['caixas-contato']}>
                <div className={styles['caixa-contato']}>
                    <span>{config.texts.contato.whatsapp.label}</span>
                    <div className={styles['numero-contato']}>
                        <FontAwesomeIcon icon={faWhatsapp} className={styles.icon} />
                        <strong>{config.links.phones.whatsappFormatted}</strong>
                    </div>
                </div>
                <div className={styles['caixa-contato']}>
                    <span>{config.texts.contato.phone.label}</span>
                    <div className={styles['numero-contato']}>
                        <FontAwesomeIcon icon={faPhoneAlt} className={styles.icon} />
                        <strong>{config.links.phones.supportFormatted}</strong>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Contato;